import { debounce } from 'lodash'
import { DependencyList, useCallback, useEffect } from 'react'

type DebounceOptions = Parameters<typeof debounce>[2] & { wait?: number }

export function useDebouncedCallback<T extends (...args: never[]) => unknown>(
	options: DebounceOptions & { flushOnUnmount?: boolean },
	callback: T,
	deps: DependencyList,
): ReturnType<typeof debounce<T>> {
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const debouncedFn = useCallback(debounce(callback, options.wait, options), deps)

	const flushOnUnmount = options.flushOnUnmount

	useEffect(() => {
		// Cleanup runs when deps change OR on unmount
		return () => {
			if (flushOnUnmount) {
				debouncedFn.flush?.()
			}
		}
	}, [debouncedFn, flushOnUnmount])

	return debouncedFn
}
